export const data = [
  {
    stt:1,
    mnp:123,
    company:'abc',
    date:'123234',
    people:'abc',
    note:'abcd',
    createDate:'2123',
    status:'sadsd',
    
  }
]